const components = {
    Multiselect() {
        return import(/* webpackChunkName: "Multiselect" */ 'vue-multiselect');
    },
    YuriLabel() {
        return import(/* webpackChunkName: "YuriLabel" */ '@/components/YuriLabel');
    },
    YuriButton() {
        return import(/* webpackChunkName: "YuriButton" */ '@/components/YuriButton');
    },
    Spinner() {
        return import(/* webpackChunkName: "Spinner" */ '@/components/Spinner');
    },
    UploadDocument() {
        return import(/* webpackChunkName: "UploadDocument" */ '@/components/UploadDocument');
    },
    DocumentsGroup() {
        return import(/* webpackChunkName: "DocumentsGroup" */ '@/components/DocumentsGroup');
    },
    DocumentItem() {
        return import(/* webpackChunkName: "DocumentItem" */ '@/components/DocumentItem');
    },
    YuriText() {
        return import(/* webpackChunkName: "YuriText" */ '@/components/YuriText');
    },
    YuriIcon() {
        return import(/* webpackChunkName: "YuriIcon" */ '@/components/YuriIcon');
    },
    OTPSignature() {
        return import(/* webpackChunkName: "OTPSignature" */ '@/components/OTPSignature');
    },
    ToggleHeader() {
        return import(/* webpackChunkName: "ToggleHeader" */ '@/components/ToggleHeader');
    },
    DatePicker() {
        return import(/* webpackChunkName: "DatePicker" */ 'vue2-datepicker');
    },
    YuriDatePicker() {
        return import(
            /* webpackChunkName: "YuriDatePicker" */ '@/components/YuriDatePicker/index.vue'
        );
    },
    VueGoogleAutocomplete() {
        return import(/* webpackChunkName: "VueGoogleAutocomplete" */ 'vue-google-autocomplete');
    },
    PositionDate() {
        return import(/* webpackChunkName: "PositionDate" */ '@/components/PositionDate');
    },
    ShowPasswordInput() {
        return import(/* webpackChunkName: "ShowPasswordInput" */ '@/components/ShowPasswordInput');
    }
};

export default components;
